/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type OutputForm_circle$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type NewOutputForm_circle$ref: FragmentReference;
declare export opaque type NewOutputForm_circle$fragmentType: NewOutputForm_circle$ref;
export type NewOutputForm_circle = {|
  +$fragmentRefs: OutputForm_circle$ref,
  +$refType: NewOutputForm_circle$ref,
|};
export type NewOutputForm_circle$data = NewOutputForm_circle;
export type NewOutputForm_circle$key = {
  +$data?: NewOutputForm_circle$data,
  +$fragmentRefs: NewOutputForm_circle$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewOutputForm_circle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OutputForm_circle"
    }
  ],
  "type": "Circle",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '0cfc46fc5769bbf894c2ada4d6b79dd0';

module.exports = node;
